module.exports = __webpack_public_path__ + "static/banner-autres-desktop-a0308be74ef52202477e6cb4dc357b8b.jpg";